import { Section, Title } from '../../components/Common/PageElement';
import React from "react";
// import "./index.css"
import {useState} from "react";
import {Container} from "react-bootstrap";
import './updates.css';

const updates = [
    {
        date: '2024-05-23',
        title: 'Bug Fixes',
        details: [
            'Fixed a bug that may shuffle the sequences when exporting the CSV file.',
            // 'Resolved a bug causing incorrect data display in the user profile.',
        ],
    },
    // {
    //     date: '2024-05-20',
    //     title: 'New Features',
    //     details: [
    //         'Added support for dark mode.',
    //         'Implemented a new search functionality for faster data retrieval.',
    //     ],
    // },
    // {
    //     date: '2024-05-15',
    //     title: 'Improvements',
    //     details: [
    //         'Enhanced the performance of the dashboard loading times.',
    //         'Updated the user interface for a more intuitive experience.',
    //     ],
    // },
];

const UpdateItem = ({ date, title, details }) => (
    <div className="update-item">
        <h3>{title} - <small>{date}</small></h3>
        <ul>
            {details.map((detail, index) => (
                <li key={index}>{detail}</li>
            ))}
        </ul>
    </div>
);

const Updates = () => (
    <Section id={'tutorial'}>
        <Container>
            <div className="Updates">
                <header className="Updates-header">
                    <h1>Update Log</h1>
                </header>
                <main>
                    {updates.map((update, index) => (
                        <UpdateItem key={index} {...update} />
                    ))}
                </main>
            </div>
        </Container>
    </Section>
);

export default Updates;
